import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ContentProvider } from './context/ContentContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Magazine from './pages/Magazine';
import IssuePage from './pages/IssuePage';
import Editions from './pages/Editions';
import ArticleDetail from './pages/ArticleDetail';
import Events from './pages/Events';
import Podcasts from './pages/Podcasts';
import Advertise from './pages/Advertise';
import ABC from './pages/ABC';
import FELAS from './pages/FELAS';
import IECL from './pages/IECL';
import The100 from './pages/The100';
import Club from './pages/Club';
import About from './pages/About';
import Contact from './pages/Contact';
import AdminApp from './admin/AdminApp';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function PublicSite() {
  return (
    <>
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/magazine" element={<Magazine />} />
          <Route path="/magazine/:slug" element={<IssuePage />} />
          <Route path="/editions" element={<Editions />} />
          <Route path="/article/:slug" element={<ArticleDetail />} />
          <Route path="/events" element={<Events />} />
          <Route path="/podcasts" element={<Podcasts />} />
          <Route path="/abc" element={<ABC />} />
          <Route path="/felas" element={<FELAS />} />
          <Route path="/iecl" element={<IECL />} />
          <Route path="/the100" element={<The100 />} />
          <Route path="/advertise" element={<Advertise />} />
          <Route path="/club" element={<Club />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <div className="grain-overlay" />
      <ContentProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/admin/*" element={<AdminApp />} />
            <Route path="/*" element={<PublicSite />} />
          </Routes>
        </BrowserRouter>
      </ContentProvider>
    </div>
  );
}

export default App;
